import { L as h } from "./like-anchor-1p1kOy4b.js";
import { F as p } from "./focusable-eNCxNBjF.js";
import { O as u } from "./observe-slot-text-DWmBsDhw.js";
import { i as d, x as r } from "./lit-element-6iugfgmM.js";
import { i as m } from "./query-D8_rwLua.js";
import { n as l } from "./property-BWlAHqg_.js";
const b = d`
    :host{vertical-align:top;--spectrum-progress-circle-size:var(--spectrum-workflow-icon-size-100);--spectrum-icon-size:var(--spectrum-workflow-icon-size-100);display:inline-flex}:host([dir]){-webkit-appearance:none}:host([disabled]){pointer-events:none;cursor:auto}#button{position:absolute;inset:0}::slotted(sp-overlay),::slotted(sp-tooltip){position:absolute}:host:after{pointer-events:none}::slotted(*){pointer-events:none}slot[name=icon]::slotted(svg),slot[name=icon]::slotted(img){fill:currentColor;stroke:currentColor;block-size:var(--spectrum-icon-size,var(--spectrum-workflow-icon-size-100));inline-size:var(--spectrum-icon-size,var(--spectrum-workflow-icon-size-100))}[icon-only]+#label{display:contents}:host([size=xs]){--spectrum-progress-circle-size:var(--spectrum-workflow-icon-size-50);--spectrum-icon-size:var(--spectrum-workflow-icon-size-50)}:host([size=s]){--spectrum-progress-circle-size:var(--spectrum-workflow-icon-size-75);--spectrum-icon-size:var(--spectrum-workflow-icon-size-75)}:host([size=l]){--spectrum-progress-circle-size:var(--spectrum-workflow-icon-size-200);--spectrum-icon-size:var(--spectrum-workflow-icon-size-200)}:host([size=xl]){--spectrum-progress-circle-size:var(--spectrum-workflow-icon-size-300);--spectrum-icon-size:var(--spectrum-workflow-icon-size-300)}:host([size=xxl]){--spectrum-progress-circle-size:var(--spectrum-workflow-icon-size-400);--spectrum-icon-size:var(--spectrum-workflow-icon-size-400)}
`;
var f = Object.defineProperty, n = (i, e, t, v) => {
  for (var c, s = void 0, o = i.length - 1; o >= 0; o--) (c = i[o]) && (s = c(e, t, s) || s);
  return s && f(e, t, s), s;
};
class a extends u(h(p), "", ["sp-overlay,sp-tooltip"]) {
  constructor() {
    super(), this.active = !1, this.type = "button", this.proxyFocus = this.proxyFocus.bind(this), this.addEventListener("click", this.handleClickCapture, { capture: !0 });
  }
  static get styles() {
    return [b];
  }
  get focusElement() {
    return this;
  }
  get hasLabel() {
    return this.slotHasContent;
  }
  get buttonContent() {
    return [r`
                <slot name="icon" ?icon-only=${!this.hasLabel}></slot>
            `, r`
                <span id="label">
                    <slot @slotchange=${this.manageTextObservedSlot}></slot>
                </span>
            `];
  }
  handleClickCapture(e) {
    if (this.disabled) return e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation(), !1;
    this.shouldProxyClick();
  }
  proxyFocus() {
    this.focus();
  }
  shouldProxyClick() {
    let e = !1;
    if (this.anchorElement) this.anchorElement.click(), e = !0;
    else if (this.type !== "button") {
      const t = document.createElement("button");
      t.type = this.type, this.insertAdjacentElement("afterend", t), t.click(), t.remove(), e = !0;
    }
    return e;
  }
  renderAnchor() {
    return r`
            ${this.buttonContent}
            ${super.renderAnchor({ id: "button", ariaHidden: !0, className: "button anchor hidden" })}
        `;
  }
  renderButton() {
    return r`
            ${this.buttonContent}
        `;
  }
  render() {
    return this.href && this.href.length > 0 ? this.renderAnchor() : this.renderButton();
  }
  handleKeydown(e) {
    const { code: t } = e;
    t === "Space" && (e.preventDefault(), this.href === void 0 && (this.addEventListener("keyup", this.handleKeyup), this.active = !0));
  }
  handleKeypress(e) {
    const { code: t } = e;
    switch (t) {
      case "Enter":
      case "NumpadEnter":
        this.click();
    }
  }
  handleKeyup(e) {
    const { code: t } = e;
    t === "Space" && (this.removeEventListener("keyup", this.handleKeyup), this.active = !1, this.click());
  }
  manageAnchor() {
    this.href && this.href.length > 0 ? (!this.hasAttribute("role") || this.getAttribute("role") === "button") && this.setAttribute("role", "link") : (!this.hasAttribute("role") || this.getAttribute("role") === "link") && this.setAttribute("role", "button");
  }
  firstUpdated(e) {
    super.firstUpdated(e), this.hasAttribute("tabindex") || this.setAttribute("tabindex", "0"), e.has("label") && (this.label ? this.setAttribute("aria-label", this.label) : this.removeAttribute("aria-label")), this.manageAnchor(), this.addEventListener("keydown", this.handleKeydown), this.addEventListener("keypress", this.handleKeypress);
  }
  updated(e) {
    super.updated(e), e.has("href") && this.manageAnchor(), this.anchorElement && (this.anchorElement.addEventListener("focus", this.proxyFocus), this.anchorElement.tabIndex = -1);
  }
  update(e) {
    super.update(e), e.has("label") && (this.label ? this.setAttribute("aria-label", this.label) : this.removeAttribute("aria-label"));
  }
}
n([l({ type: Boolean, reflect: !0 })], a.prototype, "active"), n([l({ type: String })], a.prototype, "type"), n([m(".anchor")], a.prototype, "anchorElement");
export {
  a as B
};
//# sourceMappingURL=ButtonBase-a1MtCiSI.js.map
